module.exports = __webpack_public_path__ + "static/media/carritoX.dc8e7ee5.svg";